import React from 'react';
import './addButton.css';

interface AddButtonProps {
    onClick: () => void;
    disabled?: boolean;
    isSubmitting?: boolean;
    text?: string;
}

const AddButton: React.FC<AddButtonProps> = ({
    onClick,
    disabled = false,
    isSubmitting = false,
    text = "+ Add",
}) => {
    const isButtonDisabled = disabled || isSubmitting;

    return (
        <button 
            className={`addButton-main ${!isButtonDisabled ? 'enabled' : ''} ${
                text === 'Clear' ? 'addButton-clear' : ''
            }`}
            disabled={isButtonDisabled}
            onClick={onClick}
        >
            {text}
        </button>
    );
};

export default AddButton;